function Home() {
    return(
        <>
        <div className="container-fluid pt-5 hero-header mb-5">
  <div className="slider-container">
    <div className="slide2">
      <div className="container pt-5">
        <div className="row g-5 pt-5">
          <div className="col-lg-8 align-self-center text-center text-lg-start mb-lg-5">
            <div className="btn btn-sm border rounded-pill text-white px-3 mb-3 animated slideInRight">
              RScom
            </div>
            <h1 className="display-6 text-white mb-1 animated slideInRight">
            Why you should choose RScom Networking System Solutions
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        <div className="container-fluid py-5">
  <div className="container">
    <div className="row g-5 align-items-center">
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div className="about-img about-img-cont">
          <img
            className="img-fluid"
            src="img/futuristic-computer-network-connects-global-industry-modern-warehouse-generated-by-artificial-intelligence.jpg"
          />
        </div>
        <div className="box green" />
      </div>
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
        <div className="btn btn-sm border rounded-pill text-warningS px-3 mb-3">
          WHO WE ARE
        </div>
        <h1 className="mb-4">
          RScom Network{" "}
          <span className="more-about-us-home">
            - Leading Provider of Flexible Network Infrastructure Solutions
          </span>
        </h1>
        <p className="mb-4">
          RScom Network specializes in delivering customer-centric design and
          adaptable network physical infrastructure solutions across diverse
          sectors. Our comprehensive range of fiber optics, copper, and rack
          systems caters to the unique demands of Data Centers, Enterprise
          Networks, Transportation Networks, Broadcast and CATV Networks, as
          well as Telecom and FTTx sectors.
        </p>
        <p className="mb-4">
          With over a decade of industry experience, our expert team is
          committed to delivering professional insights tailored to your market
          requirements...
        </p>
        <div className="row g-3">
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              Recognized for Excellence
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Highly Skilled Professionals
            </h6>
          </div>
          <div className="col-sm-6">
            <h6 className="mb-3">
              <i className="fa fa-check text-warningS me-2" />
              24/7 Dedicated Support
            </h6>
            <h6 className="mb-0">
              <i className="fa fa-check text-warningS me-2" />
              Competitive Pricing
            </h6>
          </div>
        </div>
        <div className="d-flex align-items-center mt-4">
          <a className="btn btn-warningS rounded-pill px-4 me-3" href="/about ">
            Read More
          </a>
          <a className="btn btn-outline-warningS btn-square me-3" href="">
            <i className="fab fa-facebook-f" />
          </a>
          <a className="btn btn-outline-warningS btn-square me-3" href="">
            <i className="fab fa-twitter" />
          </a>
          <a className="btn btn-outline-warningS btn-square me-3" href="">
            <i className="fab fa-instagram" />
          </a>
          <a className="btn btn-outline-warningS btn-square" href="">
            <i className="fab fa-linkedin-in" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="container-fluid bg-light mt-5 py-5">
  <div className="container py-5">
    <div className="row g-5 align-items-center">
      <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="btn btn-sm border rounded-pill text-warningS px-3 mb-3">
          Our Services
        </div>
        <h1 className="mb-4">
          Our Excellent Networking Solutions for Your Business
        </h1>
        <a className="btn btn-warningS rounded-pill px-4" href="">
          Read More
        </a>
      </div>
      <div className="col-lg-7">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="row g-4">
              <div className="col-12 wow fadeIn" data-wow-delay="0.1s">
                <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                  <div
                    className="service-icon btn-square"
                    style={{ fontWeight: 900, fontSize: 15 }}
                  >
                    <i className="bi bi-arrows-angle-contract fa-2x" />
                  </div>
                  <h5 className="mb-3">CPR-RATED CABLE</h5>
                </div>
              </div>
              <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                  <div className="service-icon btn-square">
                    <i className="bi bi-hdd-rack fa-2x " />
                  </div>
                  <h5 className="mb-3">DATA CENTERS</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 pt-md-4">
            <div className="row g-4">
              <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                  <div
                    className="service-icon btn-square"
                    style={{ fontWeight: 900, fontSize: 15 }}
                  >
                    <i className="bi bi-building fa-2x" />
                  </div>
                  <h5 className="mb-3">SMART BUILDING</h5>
                </div>
              </div>
              <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                <div className="service-item d-flex flex-column justify-content-center text-center rounded">
                  <div
                    className="service-icon btn-square"
                    style={{ fontWeight: 900, fontSize: 15 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={30}
                      height={30}
                      fill="currentColor"
                      className="bi bi-ethernet"
                      viewBox="0 0 16 16"
                    >
                      <path d="M14 13.5v-7a.5.5 0 0 0-.5-.5H12V4.5a.5.5 0 0 0-.5-.5h-1v-.5A.5.5 0 0 0 10 3H6a.5.5 0 0 0-.5.5V4h-1a.5.5 0 0 0-.5.5V6H2.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5M3.75 11h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25m2 0h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25m1.75.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25zM9.75 11h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25m1.75.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25z" />
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z" />
                    </svg>
                  </div>
                  <h5 className="mb-3">Predictive Analysis</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div className="container-fluid bg-warningS feature pt-5">
  <div className="container pt-5 font-chose">
    <div className="row g-5">
      <div
        className="col-lg-6 align-self-center mb-md-5 pb-md-5 wow fadeIn"
        data-wow-delay="0.3s"
      >
        <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">
          Why Choose Us
        </div>
        <h1 className="text-white mb-4">
          We're Best in AI Industry with 10 Years of Experience
        </h1>
        <div className="row g-4 pt-3">
          <div className="col-sm-6">
            <div
              className="d-flex rounded p-3"
              style={{ background: "rgba(256, 256, 256, 0.1)" }}
            >
              <i className="fa fa-users fa-3x text-white" />
              <div className="ms-3">
                <h2 className="text-white mb-0" data-toggle="counter-up">
                  23
                </h2>
                <p className="text-white mb-0">Happy Clients</p>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div
              className="d-flex rounded p-3"
              style={{ background: "rgba(256, 256, 256, 0.1)" }}
            >
              <i className="fa fa-check fa-3x text-white" />
              <div className="ms-3">
                <h2 className="text-white mb-0" data-toggle="counter-up">
                  28
                </h2>
                <p className="text-white mb-0">Project Complete</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-lg-6 align-self-end text-center text-md-end wow fadeIn"
        data-wow-delay="0.5s"
      >
        <img
          className="img-fluid"
          src="https://www.cyberlinkasp.com/wp-content/uploads/2013/07/image.png"
          width="80%"
          alt=""
        />
      </div>
    </div>
  </div>
</div>


{/* Case Start */}
<div className="container-fluid bg-light py-5">
    <div className="container py-5">
      <div
        className="mx-auto text-center wow fadeIn"
        data-wow-delay="0.1s"
        style={{ maxWidth: 500 }}
      >
        <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">
        References
        </div>
        <h1 className="mb-4">RScom Network's Sources and Citations</h1>
      </div>
      <div className="row g-4">
        <div className="col-lg-4 wow fadeIn" data-wow-delay="0.3s">
          <div className="case-item position-relative overflow-hidden rounded mb-2">
            <img className="img-fluid" src="img/2022-wimbledon-general-view.jpg" alt="" />
            <a className="case-overlay text-decoration-none" href="">
              <small>London, United Kingdom</small>
              <h5 className="lh-base text-white mb-3">
              Wimbledon 
Stadium, Junior Cort
              </h5>
            </a>
          </div>
        </div>
        <div className="col-lg-4 wow fadeIn" data-wow-delay="0.5s">
          <div className="case-item position-relative overflow-hidden rounded mb-2">
            <img className="img-fluid" src="img/13113502-6837c8dd-25ee-41b3-8265-ba9bd3b517cb (1).avif" alt="" />
            <a className="case-overlay text-decoration-none" href="">
              <small>London, United Kingdom</small>
              <h5 className="lh-base text-white mb-3">
              Everyman 
Cinema
              </h5>
            </a>
          </div>
        </div>
        <div className="col-lg-4 wow fadeIn" data-wow-delay="0.7s">
          <div className="case-item position-relative overflow-hidden rounded mb-2">
            <img className="img-fluid" src="img/defaultContentHeader.jpg" alt="" />
            <a className="case-overlay text-decoration-none" href="">
              <small>London, United Kingdom</small>
              <h5 className="lh-base text-white mb-3">
              Wimbledon 
Center 
Stadium
              </h5>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Case End */}
</>
    )
}

export default Home;